import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Forgotpassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (email === '') {
      toast.error('Please enter your email!');
      return;
    }
    try {
      // Send the request to the backend API to trigger email sending with the reset link
      const response = await axios.post(`${process.env.REACT_APP_API_URL}auth/forgotpassword`, {
        email, // Only send the email for the password reset request
      });

      if (response.data.status === 'error') {
        toast.error(response.data.message);
      } else {
        // Show success message
        toast.success(response.data.message);
        
        // Redirect after success
        setTimeout(() => {
          navigate('/resetpassword');
        }, 3000);
      }
    } catch (err) {
      toast.error('Error sending reset link!');
      console.error('Error:', err);
    }
  };

  return (
    <div className="container-fluid Login-section">
      <div className="login-form bg-light shadow p-4 rounded">
        <div
          style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
          }}
        >
          <Link to="/" className="btn btn-success">
            <Icon.ArrowLeft className="me-2" style={{ fontSize: '1.5em' }} />
          </Link>
        </div>

        <h6 className="mb-3 fw-bold text-muted">
          <Icon.Key className="me-2" />
          Forgot Password
        </h6>

        {/* Email Input */}
        <div className="mb-3">
          <input
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            className="form-control shadow-none"
            placeholder="Enter Your Email"
          />
        </div>

        {/* Submit Button */}
        <div className="w-100 d-flex justify-content-center mt-4">
          <button onClick={handleSubmit} className="btn btn-success w-100">
            Submit
          </button>
        </div>

        <ToastContainer theme="dark" autoClose={2000} />
      </div>
    </div>
  );
};

export default Forgotpassword;
